import React from 'react';
import { FieldTextInput } from '../../../../components';
import UserFieldPhoneNumber from '../../../AuthenticationPage/UserFieldPhoneNumber';
import { required } from '../../../../util/validators';
import { TalentSignupStep, UserType } from '../../../../util/enums';
import css from './EditListingDetailsForm.module.css';

const DefaultUserInfoFields = ({
  userType,
  intl,
  userTypeConfig,
  currentStep,
  formId,
  isEditListingDetailsForm = false,
}) => {
  return (
    <>
      {(userType !== UserType.TALENT || currentStep === TalentSignupStep.INITIAL) && (
        <div className={css.formRow}>
          {userType === UserType.BRAND ||
          userType === UserType.AGENCY ||
          userType === UserType.SCHOOL ? (
            <FieldTextInput
              className={css.formFld}
              type="text"
              id={formId ? `${formId}.organizationName` : 'organizationName'}
              name="organizationName"
              autoComplete="organization"
              label={intl.formatMessage({
                id: `DefaultUserInfoFields.${userType.toLowerCase()}NameLabel`,
              })}
              placeholder={intl.formatMessage({
                id: `DefaultUserInfoFields.${userType.toLowerCase()}NamePlaceholder`,
              })}
              validate={required(
                intl.formatMessage({
                  id: `DefaultUserInfoFields.${userType.toLowerCase()}NameRequired`,
                })
              )}
            />
          ) : (
            <>
              <FieldTextInput
                className={css.formFld}
                type="text"
                id={formId ? `${formId}.firstName` : 'firstName'}
                name="firstName"
                autoComplete="given-name"
                label={intl.formatMessage({
                  id: 'DefaultUserInfoFields.firstNameLabel',
                })}
                placeholder={intl.formatMessage({
                  id: 'DefaultUserInfoFields.firstNamePlaceholder',
                })}
                validate={required(
                  intl.formatMessage({
                    id: 'DefaultUserInfoFields.firstNameRequired',
                  })
                )}
              />
              <FieldTextInput
                className={css.formFld}
                type="text"
                id={formId ? `${formId}.lastName` : 'lastName'}
                name="lastName"
                autoComplete="family-name"
                label={intl.formatMessage({
                  id: 'DefaultUserInfoFields.lastNameLabel',
                })}
                placeholder={intl.formatMessage({
                  id: 'DefaultUserInfoFields.lastNamePlaceholder',
                })}
                validate={required(
                  intl.formatMessage({
                    id: 'DefaultUserInfoFields.lastNameRequired',
                  })
                )}
              />
            </>
          )}
        </div>
      )}
      {(userType !== UserType.TALENT || currentStep === TalentSignupStep.INITIAL) && (
        <div className={css.formRow}>
          <FieldTextInput
            className={css.formFld}
            type="email"
            id={formId ? `${formId}.email` : 'email'}
            name="email"
            autoComplete="email"
            label={intl.formatMessage({
              id: 'DefaultUserInfoFields.emailLabel',
            })}
            placeholder={intl.formatMessage({
              id: 'DefaultUserInfoFields.emailPlaceholder',
            })}
            disabled={isEditListingDetailsForm}
          />
          <UserFieldPhoneNumber
            formName="SignupForm"
            className={css.formFld}
            rootClassName={css.formFld}
            userTypeConfig={userTypeConfig}
            intl={intl}
          />
        </div>
      )}
    </>
  );
};

export default DefaultUserInfoFields;
